import Cookies from 'universal-cookie';
import { COOKIE_NAMES } from 'lib/enums/cookies';

const getIsVipUser = (): boolean => {
  const cookies = new Cookies();

  return cookies.get(COOKIE_NAMES.QH_USER_IS_VIP) === 'true';
};

export default getIsVipUser;
